var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBaggageSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5V3.75C7.5 3.0625 8.0625 2.5 8.75 2.5H11.25C11.9375 2.5 12.5 3.0625 12.5 3.75V5H11.25V3.75H8.75V5H7.5ZM18.75 6.875V16.25C18.75 16.9375 18.1875 17.5 17.5 17.5H2.5C1.8125 17.5 1.25 16.9375 1.25 16.25V6.875C1.25 6.1875 1.8125 5.625 2.5 5.625H17.5C18.1875 5.625 18.75 6.1875 18.75 6.875ZM6.25 6.875V16.25H13.75V6.875H6.25ZM2.5 16.25H5V6.875H2.5V16.25ZM17.5 6.875H15V16.25H17.5V6.875Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaggageSuitcase);
export default __webpack_public_path__ + "static/media/icon-baggage-suitcase.29b1f69206a7e1274b553cefeb268c23.svg";
export { ForwardRef as ReactComponent };